import { useEffect } from "react";
import { ArrowRight, EnvelopeSimple, CalendarCheck } from "@phosphor-icons/react";
import { Reveal, MaskLine, openBooking } from "@/lib/anim";

const GHL_SCRIPT = "https://link.mobyle.agency/js/form_embed.js";

export const Contact = () => {
  useEffect(() => {
    if (document.querySelector(`script[src="${GHL_SCRIPT}"]`)) return;
    const s = document.createElement("script");
    s.src = GHL_SCRIPT;
    s.async = true;
    document.body.appendChild(s);
  }, []);

  return (
    <section
      id="contact"
      className="relative py-28 md:py-40 bg-black/20 overflow-hidden"
      data-testid="contact-section"
    >
      <div className="absolute inset-0 bg-[radial-gradient(circle_at_15%_20%,rgba(64,224,208,0.12),transparent_40%),radial-gradient(circle_at_85%_80%,rgba(139,92,246,0.14),transparent_45%),radial-gradient(circle_at_60%_10%,rgba(59,110,255,0.1),transparent_40%)]" />
      <div className="relative max-w-7xl mx-auto px-6 lg:px-8 grid md:grid-cols-2 gap-14 md:gap-20 items-start">
        <div>
          <Reveal>
            <span className="text-xs uppercase tracking-[0.25em] text-teal/80">
              Let&apos;s build it
            </span>
          </Reveal>
          <h2 className="mt-6 font-heading font-extrabold tracking-tighter text-white text-4xl sm:text-5xl md:text-6xl leading-[0.98]">
            <MaskLine>You&apos;ve had the</MaskLine>
            <MaskLine delay={0.08}>vision long enough.</MaskLine>
            <MaskLine delay={0.16}>
              <span className="text-teal text-glow-teal">Let&apos;s build it.</span>
            </MaskLine>
          </h2>
          <Reveal delay={1}>
            <p className="mt-8 text-white/60 leading-relaxed max-w-md">
              Book your free build consult. You talk, we listen — and you walk
              away with a blueprint: features, automations, timeline and price.
              In writing. No obligation.
            </p>
          </Reveal>
          <Reveal delay={2}>
            <div className="mt-8 flex items-center gap-3 text-white/70">
              <EnvelopeSimple size={20} className="text-teal" />
              <a
                href="mailto:hello@gomobyle.com"
                className="hover:text-teal transition-colors"
                data-testid="contact-email-link"
              >
                hello@gomobyle.com
              </a>
            </div>
          </Reveal>
          <Reveal delay={2}>
            <button
              onClick={openBooking}
              className="group mt-4 inline-flex items-center gap-2 text-teal hover:text-white transition-colors"
              data-testid="contact-book-call"
            >
              <CalendarCheck size={18} weight="fill" />
              Prefer to talk now? Book a call
              <ArrowRight size={15} weight="bold" className="group-hover:translate-x-1 transition-transform" />
            </button>
          </Reveal>
        </div>

        <Reveal delay={1}>
          <div
            className="rounded-2xl border border-white/10 bg-transparent overflow-hidden shadow-glow-teal"
            data-testid="contact-form"
          >
            <iframe
              src="https://link.mobyle.agency/widget/form/bc8E8QfnllIrh0uzGrun"
              style={{ width: "100%", height: "680px", border: "none", borderRadius: "3px" }}
              id="inline-bc8E8QfnllIrh0uzGrun"
              data-layout="{'id':'INLINE'}"
              data-trigger-type="alwaysShow"
              data-trigger-value=""
              data-activation-type="alwaysActivated"
              data-activation-value=""
              data-deactivation-type="neverDeactivate"
              data-deactivation-value=""
              data-form-name="Mobyle Campaign Landing Page Form"
              data-height="621"
              data-layout-iframe-id="inline-bc8E8QfnllIrh0uzGrun"
              data-form-id="bc8E8QfnllIrh0uzGrun"
              title="Mobyle Campaign Landing Page Form"
            />
          </div>
        </Reveal>
      </div>
    </section>
  );
};
